import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import apiService from '../services/apiService';
import MemberTable from '../components/members/MemberTable';
import MemberList from '../components/members/MemberList';
import ViewToggle from '../components/members/ViewToggle';
import Modal from '../components/common/Modal';
import { NewMemberForm } from '../components/members/MemberForm';

const STATUS_MAP = { active: 'Active', pending: 'Pending', rejected: 'Rejected', inactive: 'Inactive' };

export default function MembersPage() {
  const navigate = useNavigate();
  const [members, setMembers] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  const [viewMode, setViewMode] = useState('table');
  const [filters, setFilters] = useState({ status: 'active', search: '' });
  const [isAddModalOpen, setIsAddModalOpen] = useState(false);

  const fetchMembers = async () => {
    setIsLoading(true);
    setError(null);
    try { setMembers(await apiService.getMembers(filters)); }
    catch { setError('Failed to load members.'); }
    finally { setIsLoading(false); }
  };

  useEffect(() => { fetchMembers(); }, [filters]); // eslint-disable-line

  const handleCreate = async (data) => {
    try { await apiService.createMember(data); await fetchMembers(); setIsAddModalOpen(false); }
    catch { setError('Failed to create member.'); }
  };

  return (
    <div className="p-3 sm:p-6">
      <div className="mb-4 sm:mb-6">
        <h1 className="text-2xl sm:text-3xl font-bold text-slate-900 mb-1">Members</h1>
        <p className="text-slate-600 text-sm">Manage account holders and family members</p>
      </div>

      {error && (
        <div className="mb-4 p-3 bg-red-50 border border-red-200 rounded-lg text-red-700 text-sm">{error}</div>
      )}

      <div className="flex justify-end mb-3">
        <ViewToggle view={viewMode} onToggle={setViewMode} />
      </div>

      {viewMode === 'table' ? (
        <MemberTable
          members={members}
          filters={filters}
          setFilters={setFilters}
          statusMap={STATUS_MAP}
          isLoading={isLoading}
          onMemberClick={(m) => navigate(`/members/${m.id}`)}
          onAddMember={() => setIsAddModalOpen(true)}
        />
      ) : (
        <MemberList
          members={members}
          filters={filters}
          setFilters={setFilters}
          statusMap={STATUS_MAP}
          isLoading={isLoading}
          onMemberClick={(m) => navigate(`/members/${m.id}`)}
          onAddMember={() => setIsAddModalOpen(true)}
        />
      )}

      {isAddModalOpen && (
        <Modal onClose={() => setIsAddModalOpen(false)}>
          <NewMemberForm onCreateMember={handleCreate} onCancel={() => setIsAddModalOpen(false)} />
        </Modal>
      )}
    </div>
  );
}
